import '../Styles/TodosError.css';

function TodosError({searchValue, setSearchValue}) {
  
  return(
    <p>Error...</p>
  )
}

export {TodosError};